import { WebSessionService } from '@legalzoom/web-session-sdk';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { TrackJsErrorLogService, IQueueEntry } from '@legalzoom/business-formation-sdk';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService, CookieOptions } from 'ngx-cookie';
import { AppService } from '../state/app';
import { CookieName, ProductName } from '../constants/product-domain';
import { HelperService } from '@legalzoom/lib-checkout';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public currentToken: string;
  constructor(
    private webSessionService: WebSessionService,
    private appService: AppService,
    private cookieService: CookieService,
    private trackJS: TrackJsErrorLogService,
    private helperService: HelperService
  ) { }

  getAuthToken() {
    return this.currentToken;
  }

  refreshToken(): Observable<string> {
    const app = this.appService.app;
    const sessionId = app.sessionId;
    const authToken = app.accessToken;
    return this.webSessionService.refreshOAuth2Token(authToken, sessionId)
      .pipe(map(refreshOAuth2TokenResponse => {
        app.accessToken = refreshOAuth2TokenResponse.accessToken;
        this.appService.app = app;

        const cookieDomain = window.location.hostname === 'localhost' ? 'localhost' : 'legalzoom.com';
        const cookieOptions: CookieOptions = { domain: cookieDomain, storeUnencoded: true };

        this.cookieService.put(
          CookieName.USERIDENTIFICATION,
          'consultation_id=' + decodeURIComponent(refreshOAuth2TokenResponse.accessToken) +
          '&cid=' + this.appService.app.customerId,
          cookieOptions
        );

        this.refreshCheckoutToken(refreshOAuth2TokenResponse.accessToken);

        return this.currentToken = refreshOAuth2TokenResponse.accessToken;
      }));

  }

  refreshCheckoutToken(token: string): void {
    this.helperService.updateToken(token);
  }

  prepareGetCustomerAndSession(sessionId, authToken, customerId): IQueueEntry {
    return {
      name: 'prepareGetCustomerAndSession auth.service',
      // clearQueueOnError: false,
      pre: () => {
        return this.webSessionService.getCustomerAndSession(sessionId, '', customerId);
      },
      post: (response) => {
        const appState = this.appService.app;
        appState.customerId = response.customerId;
        appState.accessToken = authToken;
        appState.sessionId = response.session.find(s => s.key === 'TIMESTRING').value;
        appState.loginEmail = response.session.find(s => s.key === 'UserName').value;

        this.appService.app = appState;
      },
      error: (error: HttpErrorResponse) => {
        console.log(error.message);
        this.trackJS.track(ProductName.LLC, 'auth.service', error);
        return of(null);
      }
    };
  }
}
